import React, { Component } from "react";
import IGetCategoryCatalogItemsDTO from "../../../models/DTO/IGetCategoryCatalogItemsDTO";
import IGetSubCategoriesDTO from "../../../models/DTO/IGetSubCategoriesDTO";
import IOnGetCategoryCatalogItemsDTO from "../../../models/DTO/IOnGetCategoryCatalogItemsDTO";
import IOnGetSubCategoriesDTO from "../../../models/DTO/IOnGetSubCategoriesDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import ICatalog_Item from "../../../models/ICatalog_Item";
import ICategory from "../../../models/ICategory";
import IOrder from "../../../models/IOrder";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IVendorModel from "../../../models/IVendorModel";
import { LoadingResults } from "../../shared/LoadingResults/LoadingResults";
import OwCategoryCatalogItemDetailRow from "../OwCategoryCatalogItemDetailRow/OwCategoryCatalogItemDetailRow";
import "./OwCatalogCategoryRow.scss";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IWarehouse from "../../../models/IWarehouse";
import OwButton from "../../shared/OwButton/OwButton";
import { Socket } from "socket.io-client";
import Typeahead from "../../shared/Typeahead/Typeahead";
import ITypeaheadCatalogItemDTO from "../../../models/DTO/ITypeaheadCatalogItemDTO";
import IOnTypeaheadCatalogItemDTO from "../../../models/DTO/IOnTypeaheadCatalogItemDTO";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import { SidebarCatalogItemViewer } from "../SidebarCatalogItemViewer/SidebarCatalogItemViewer";
import { IAddBulkItems } from "@models/IAddBulkItems";

type Props = {
    addToCart: (items: IAddBulkItems[]) => void;
    socket: Socket;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    vendorModel: IVendorModel;
    category: ICategory;
    order: IOrder;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    warehouses: IWarehouse[];
};

type State = {
    isOpen: boolean;
    subCategories: ICategory[];
    catalogItems: ICatalog_Item[];
    searchedItems: ICatalog_Item[];
    retrievedCatalogItems: boolean;
    loadedInitialSubCategories: boolean;
    loadedInitialCatalogItems: boolean;
    isLoading: boolean;
    totalItems: number;
    limit: number;
    offset: number;
};

class OwCatalogCategoryRow extends Component<Props, State> {
    sockets: IUiSocketSetup[] = [];

    readonly state: State = {
        isOpen: false,
        subCategories: [],
        catalogItems: [],
        searchedItems: [],
        retrievedCatalogItems: false,
        loadedInitialSubCategories: false,
        loadedInitialCatalogItems: false,
        isLoading: false,
        totalItems: 0,
        limit: 20,
        offset: 0,
    };

    constructor(props: any) {
        super(props);

        this.sockets = [
            { endpoint: EndpointsEnum.CategoriesOnGetSubCategories, fn: this.onGetSubCategories },
            { endpoint: EndpointsEnum.CategoriesOnGetCategoryCatalogItems, fn: this.onGetCategoryCatalogItems },
            { endpoint: EndpointsEnum.CatalogItemOnTypeaheadCatalogItem, fn: this.onFindItems },
        ];
    }

    componentDidMount(): void {
        for (const socket of this.sockets) {
            this.props.socket.on(socket.endpoint, socket.fn);
        }
    }

    componentWillUnmount(): void {
        for (const socket of this.sockets) {
            this.props.socket.removeListener(socket.endpoint, socket.fn);
        }
    }

    toggleOpen = () => {
        this.setState(
            {
                isOpen: !this.state.isOpen,
                isLoading: false,
            },
            () => {
                if (this.state.isOpen && !this.state.subCategories.length && this.props.category.guid !== "NEW_RELEASES") {
                    this.getSubCategories();
                }

                if (this.state.isOpen && !this.state.retrievedCatalogItems) {
                    this.getCategoryCatalogItems();
                }
            }
        );
    };

    loadMoreItems = () => {
        this.setState(
            {
                offset: this.state.offset + 1,
            },
            () => {
                this.getCategoryCatalogItems();
            }
        );
    };

    getCategoryCatalogItems = () => {
        if (!this.props.order.Price_Group) {
            return;
        }

        const payload: IGetCategoryCatalogItemsDTO = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            vendorGuid: this.props.vendorModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            categoryGuid: this.props.category.guid,
            priceGroupGuid: this.props.order.Price_Group.guid,
            catalogGuid: this.props.order.Catalog!.guid,
            includeTotalItems: !this.state.loadedInitialCatalogItems,
            includeAttributes: true,
            offset: this.state.offset,
            limit: this.state.limit,
        };

        this.props.socket.emit(EndpointsEnum.CategoriesGetCategoryCatalogItems, payload);
    };

    onGetCategoryCatalogItems = (data: IOnGetCategoryCatalogItemsDTO) => {
        if (data.categoryGuid === this.props.category.guid) {
            const state: State = {
                ...this.state,
                retrievedCatalogItems: true,
                loadedInitialCatalogItems: true,
                isLoading: false,
            };

            const catalogItems = this.state.catalogItems;

            catalogItems.push(...data.catalogItems);

            state.catalogItems = catalogItems;

            if (data.totalItems) {
                state.totalItems = data.totalItems;
            }

            this.setState(state);
        }
    };

    getSubCategories = () => {
        const payload: IGetSubCategoriesDTO = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            vendorGuid: this.props.vendorModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            parentCategoryGuid: this.props.category.guid,
        };

        this.props.socket.emit(EndpointsEnum.CategoriesGetSubCategories, payload);
    };

    onGetSubCategories = (data: IOnGetSubCategoriesDTO) => {
        let isSubCategories = false;

        for (const category of data.categories) {
            if (category.parent_category_id === this.props.category.id) {
                isSubCategories = true;
            }
        }

        if (isSubCategories) {
            this.setState({
                subCategories: data.categories,
                loadedInitialSubCategories: true,
                isLoading: false,
            });
        }
    };

    addToCart = (item: IAddBulkItems) => {
        this.props.addToCart([item]);
    };

    findItems = (name: string) => {
        const payload: ITypeaheadCatalogItemDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            vendorGuid: this.props.vendorModel.guid,
            catalogGuid: this.props.order.Catalog!.guid,
            categoryId: this.props.category.id,
            name,
            includeTotal: true,
            options: {
                searchName: true,
                searchDescription: true,
                searchSku: true,
                searchUpc: true,
            },
        };

        this.props.socket.emit(EndpointsEnum.CatalogItemTypeaheadCatalogItem, payload);
    };

    onFindItems = (data: IOnTypeaheadCatalogItemDTO) => {
        this.setState({
            searchedItems: data.catalog_items,
        });
    };

    clearFoundItems = () => {
        this.setState({
            searchedItems: [],
        });
    };

    render() {
        let icon = "fas fa-plus-square fa-lg";

        if (this.state.isOpen) {
            icon = "fas fa-minus-square fa-lg";
        }

        let showCount = false;

        if (this.state.totalItems) {
            showCount = true;
        }

        return (
            <div className="OwCatalogCategoryRow d-block">
                <div>
                    <span className={"pointer"} onClick={this.toggleOpen}>
                        <i className={icon} /> {this.props.category.name}{" "}
                        {showCount ? (
                            <span>
                                ({this.state.catalogItems.length}) of ({this.state.totalItems})
                            </span>
                        ) : null}
                        {this.state.isOpen && !this.state.loadedInitialSubCategories && !this.state.loadedInitialCatalogItems ? (
                            <LoadingResults />
                        ) : null}
                    </span>

                    {this.state.isOpen ? (
                        <div>
                            <Typeahead
                                placeholder={"Search"}
                                isSelectableFn={() => true}
                                typeaheadApiFn={this.findItems}
                                clearTypeaheadCallback={this.clearFoundItems}
                            />
                        </div>
                    ) : null}
                </div>
                <div className={"ms-4 mb-2"}>
                    {this.state.isOpen && this.state.searchedItems.length ? (
                        <div className={"mb-4"}>
                            {this.state.searchedItems.map((catalogItem) => {
                                if (catalogItem.is_alternate_source && !catalogItem.is_customer_orderable) {
                                    return null;
                                }
                                return (
                                    <div className={"mb-2"} key={catalogItem.guid}>
                                        <div>
                                            <OwCategoryCatalogItemDetailRow
                                                userModel={this.props.userModel}
                                                supplierModel={this.props.supplierModel}
                                                vendorModel={this.props.vendorModel}
                                                catalogItem={catalogItem}
                                                order={this.props.order}
                                                addToCart={this.addToCart}
                                                bulkAddToCart={this.props.addToCart}
                                                socket={this.props.socket}
                                                notifyFn={this.props.notifyFn}
                                                warehouses={this.props.warehouses}
                                            />
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    ) : null}
                    {this.state.isOpen && this.state.loadedInitialSubCategories && this.props.category.has_dependents
                        ? this.state.subCategories
                              .filter((item) => !item.hide_category)
                              .map((category, index) => {
                                  return (
                                      <OwCatalogCategoryRow
                                          key={index}
                                          category={category}
                                          supplierModel={this.props.supplierModel}
                                          vendorModel={this.props.vendorModel}
                                          userModel={this.props.userModel}
                                          socket={this.props.socket}
                                          addToCart={this.props.addToCart}
                                          order={this.props.order}
                                          notifyFn={this.props.notifyFn}
                                          warehouses={this.props.warehouses}
                                      />
                                  );
                              })
                        : null}
                </div>
                {this.state.isOpen &&
                this.state.loadedInitialCatalogItems &&
                this.state.catalogItems.length &&
                !this.state.searchedItems.length ? (
                    <div className={"ms-4 mb-2"}>
                        {this.state.catalogItems.map((catalogItem) => {
                            if (catalogItem.is_alternate_source && !catalogItem.is_customer_orderable) {
                                return null;
                            }
                            return (
                                <div className={"mb-2"} key={catalogItem.guid}>
                                    <OwCategoryCatalogItemDetailRow
                                        userModel={this.props.userModel}
                                        supplierModel={this.props.supplierModel}
                                        vendorModel={this.props.vendorModel}
                                        catalogItem={catalogItem}
                                        order={this.props.order}
                                        addToCart={this.addToCart}
                                        bulkAddToCart={this.props.addToCart}
                                        socket={this.props.socket}
                                        notifyFn={this.props.notifyFn}
                                        warehouses={this.props.warehouses}
                                    />
                                </div>
                            );
                        })}
                    </div>
                ) : null}

                {this.state.isOpen && this.state.catalogItems.length < this.state.totalItems ? (
                    <div className={"mt-2 mb-2 text-center"}>
                        <OwButton title={"load_more"} fn={this.loadMoreItems} className={"btn btn-danger"} />
                    </div>
                ) : null}
            </div>
        );
    }
}

export default OwCatalogCategoryRow;
